import { getMobileAppVersion } from '@yandex-int/k-common/utils/service/user-agent';

/**
 * Возвращает инстанс flutter_inappwebview, у которого можно вызвать хэндлер,
если мы находимся в WebView (в мобильном приложении)
 */
export const useMobileAppWebview = () => {
    // Наличие inAppWebView означает, что мы находимся в WebView (в мобильном приложении)
    const inAppWebView =
        typeof window !== 'undefined' &&
        getMobileAppVersion(window.navigator?.userAgent) !== null &&
        window.flutter_inappwebview;

    return inAppWebView || null;
};
